import { useEffect, useState } from "react";
import { Outlet, Link, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { Drawer, Dropdown, Layout, Menu, Spin } from "antd";
import MediaQuery from "react-responsive";

import { CheckPermission } from "scripts/helpers";
import {
	openMenu,
	setRoute,
	updateCities,
	updateProvinces,
	updateSettings,
	updateUser,
} from "scripts/reducer";
import API from "scripts/api";
import Resources from "scripts/resources";
import Footer from "components/Footer";

const { Header, Sider, Content } = Layout;

const Component = ({
	onOpenMenu,
	onUpdateCities,
	onUpdateProvinces,
	onUpdateSettings,
	onUpdateUser,
	openKey,
	routes,
	selectedKey,
	user,
}) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { loaded, visible } = state;
	const { fullName, permissions } = user;
	const { navigate } = useNavigate();

	const showDrawer = () => {
		setState((prevState) => ({ ...prevState, visible: true }));
	};

	const hideDrawer = () => {
		setState((prevState) => ({ ...prevState, visible: false }));
	};

	const handleMenu = ({ key }) => {
		onOpenMenu(openKey === key ? "" : key);
	};

	const handleLogout = () => {
		API.auth
			.logout()
			.then(() => {
				API.delCookie();
			})
			.catch(() => {});
	};

	const componentDidMount = () => {
		const token = API.getCookie();

		if (token) {
			API.auth
				.me()
				.then((user) => {
					onUpdateUser(user);
					if (user.permissions.length > 0) {
						Promise.all([
							API.settings.details(),
							API.cities({ paginate: false }),
							API.provinces({ paginate: false }),
						])
							.then(
								([
									{ data: settings },
									{ data: cities },
									{ data: provinces },
								]) => {
									onUpdateCities(cities);
									onUpdateProvinces(provinces);
									onUpdateSettings(settings);

									setState((prevState) => ({ ...prevState, loaded: true }));
								}
							)
							.catch(() => {
								API.delCookie();
								navigate("/auth/login");
							});
					} else {
						API.delCookie();
						window.location = "/auth/login";
					}
				})
				.catch(() => {});
		} else {
			window.location = "/auth/login";
		}
	};

	useEffect(componentDidMount, []);

	const menu = (
		<>
			<Link to="/" className="sp-default-logo">
				<img src="/images/logo-white.png" alt={Resources.bk} />
				{Resources.adminPanel}
			</Link>
			<Menu
				mode="inline"
				theme="dark"
				items={routes
					.filter(
						(o) =>
							(o.component || o.routes) &&
							(!o.authority || CheckPermission(permissions, o.authority))
					)
					.map(({ icon, name, path, routes, title }) => {
						if (routes) {
							const _routes = routes.filter(
								(p) =>
									p.component &&
									(!p.authority || CheckPermission(permissions, p.authority))
							);

							if (_routes.length) {
								return {
									key: name,
									label: (
										<>
											{icon}
											{title}
										</>
									),
									children: _routes.map((o) => ({
										key: o.name,
										label: (
											<Link to={o.path}>
												{o.icon}
												{o.title}
											</Link>
										),
									})),
									onTitleClick: handleMenu,
								};
							}
						} else {
							return {
								key: name,
								label: (
									<Link to={path}>
										{icon}
										{title}
									</Link>
								),
								onClick: hideDrawer,
							};
						}
					})}
				selectedKeys={[selectedKey]}
				openKeys={[openKey]}
				className="sp-default-menu"
			/>
		</>
	);

	const headerMenu = {
		items: [
			{
				label: (
					<>
						<i className="fa fa-sign-out" /> {Resources.logout}
					</>
				),
				key: "3",
				onClick: handleLogout,
			},
		],
	};

	return loaded ? (
		<Layout className="sp-default-layout">
			<MediaQuery minWidth={1200}>
				<Sider width={220}>{menu}</Sider>
			</MediaQuery>
			<Layout>
				<Header>
					<MediaQuery maxWidth={1200}>
						<i className="drawer-trigger fa fa-bars" onClick={showDrawer} />
					</MediaQuery>
					<Dropdown
						menu={headerMenu}
						trigger={["click"]}
						overlayClassName="sp-default-dropdown"
					>
						<div>{fullName || ""}</div>
					</Dropdown>
				</Header>
				<Content>
					<Outlet />
				</Content>
				<Footer />
				<MediaQuery maxWidth={1200}>
					<Drawer
						open={visible}
						closable={false}
						onClose={hideDrawer}
						placement="right"
						width={220}
						className="sp-default-drawer"
					>
						{menu}
					</Drawer>
				</MediaQuery>
			</Layout>
		</Layout>
	) : (
		<Spin className="sp-main-spin" />
	);
};

export default connect(
	(state) => {
		return {
			selectedKey: state.selectedKey,
			user: state.user,
			openKey: state.openKey,
		};
	},
	(dispatch) => {
		return {
			onOpenMenu: (data) => dispatch(openMenu(data)),
			onSetRoute: (data) => dispatch(setRoute(data)),
			onUpdateCities: (data) => dispatch(updateCities(data)),
			onUpdateProvinces: (data) => dispatch(updateProvinces(data)),
			onUpdateSettings: (data) => dispatch(updateSettings(data)),
			onUpdateUser: (data) => dispatch(updateUser(data)),
		};
	}
)(Component);
